import TemplateView from "../../../TemplateView"
import {SCOPE_CELL_STATUS} from "./ScopeCell"
import SelectedUsersBlock from "./SelectedUsersBlock"

export default class TeamCellDetailsBlock extends TemplateView {

    constructor() {
        super()

        this.state = {
            status: SCOPE_CELL_STATUS.ALL,
            assignedUsersCount: 0,
        }

        this.onStatePropertyChanged('assignedUsersCount', (assignedUsersCount) => {
            this.scopeDetails.setState({assignedUsersCount})
        })

        this.onStatePropertyChanged('status', (status) => {
            this.$scopeDetails.toggle(status === SCOPE_CELL_STATUS.SELECTED)
        })
    }

    templateHtml() {
        return "<div class='cellDetailsBlock'>" +
               "    <div class='scopeDetails'></div>" +
               "</div>"
    }

    afterRender() {
        this.$scopeDetails = this.find('.scopeDetails')
        this.scopeDetails = new SelectedUsersBlock().init(this.$scopeDetails)
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/user/permissions/TeamCellDetailsBlock.js